function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var $625ad1e1f4c43bc1$exports = require("./CalendarDate.main.js");
var $af14c9812fdceb33$exports = require("./GregorianCalendar.main.js");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
$parcel$export(module.exports, "IndianCalendar", function () {
  return $5f1dfa5c67609fe6$export$39f31c639fa15726;
});
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.

// Starts in 78 AD,
var $5f1dfa5c67609fe6$var$INDIAN_ERA_START = 78;
// The Indian year starts 80 days later than the Gregorian year.
var $5f1dfa5c67609fe6$var$INDIAN_YEAR_START = 80;
var $5f1dfa5c67609fe6$export$39f31c639fa15726 = /*#__PURE__*/function (_ref) {
  function $5f1dfa5c67609fe6$export$39f31c639fa15726() {
    var _this;
    _classCallCheck(this, $5f1dfa5c67609fe6$export$39f31c639fa15726);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, $5f1dfa5c67609fe6$export$39f31c639fa15726, [].concat(args)), _this.identifier = 'indian';
    return _this;
  }
  _inherits($5f1dfa5c67609fe6$export$39f31c639fa15726, _ref);
  return _createClass($5f1dfa5c67609fe6$export$39f31c639fa15726, [{
    key: "fromJulianDay",
    value: function fromJulianDay(jd) {
      // Gregorian date for Julian day
      var date = _superPropGet($5f1dfa5c67609fe6$export$39f31c639fa15726, "fromJulianDay", this, 3)([jd]);
      // Year in Saka era
      var indianYear = date.year - $5f1dfa5c67609fe6$var$INDIAN_ERA_START;
      // Day number in Gregorian year (starting from 0)
      var yDay = jd - (0, $af14c9812fdceb33$exports.gregorianToJulianDay)(date.era, date.year, 1, 1);
      var leapMonth;
      if (yDay < $5f1dfa5c67609fe6$var$INDIAN_YEAR_START) {
        //  Day is at the end of the preceding Saka year
        indianYear--;
        // Days in leapMonth this year, previous Gregorian year
        leapMonth = (0, $af14c9812fdceb33$exports.isLeapYear)(date.year - 1) ? 31 : 30;
        yDay += leapMonth + 155 + 90 + 10;
      } else {
        // Days in leapMonth this year
        leapMonth = (0, $af14c9812fdceb33$exports.isLeapYear)(date.year) ? 31 : 30;
        yDay -= $5f1dfa5c67609fe6$var$INDIAN_YEAR_START;
      }
      var indianMonth;
      var indianDay;
      if (yDay < leapMonth) {
        indianMonth = 1;
        indianDay = yDay + 1;
      } else {
        var mDay = yDay - leapMonth;
        if (mDay < 155) {
          indianMonth = Math.floor(mDay / 31) + 2;
          indianDay = mDay % 31 + 1;
        } else {
          mDay -= 155;
          indianMonth = Math.floor(mDay / 30) + 7;
          indianDay = mDay % 30 + 1;
        }
      }
      return new (0, $625ad1e1f4c43bc1$exports.CalendarDate)(this, indianYear, indianMonth, indianDay);
    }
  }, {
    key: "toJulianDay",
    value: function toJulianDay(date) {
      var extendedYear = date.year + $5f1dfa5c67609fe6$var$INDIAN_ERA_START;
      var _ref2 = (0, $af14c9812fdceb33$exports.fromExtendedYear)(extendedYear),
        _ref3 = _slicedToArray(_ref2, 2),
        era = _ref3[0],
        year = _ref3[1];
      var leapMonth;
      var jd;
      if ((0, $af14c9812fdceb33$exports.isLeapYear)(year)) {
        leapMonth = 31;
        jd = (0, $af14c9812fdceb33$exports.gregorianToJulianDay)(era, year, 3, 21);
      } else {
        leapMonth = 30;
        jd = (0, $af14c9812fdceb33$exports.gregorianToJulianDay)(era, year, 3, 22);
      }
      if (date.month === 1) return jd + date.day - 1;
      jd += leapMonth + Math.min(date.month - 2, 5) * 31;
      if (date.month >= 8) jd += (date.month - 7) * 30;
      jd += date.day - 1;
      return jd;
    }
  }, {
    key: "getDaysInMonth",
    value: function getDaysInMonth(date) {
      if (date.month === 1 && (0, $af14c9812fdceb33$exports.isLeapYear)(date.year + $5f1dfa5c67609fe6$var$INDIAN_ERA_START)) return 31;
      if (date.month >= 2 && date.month <= 6) return 31;
      return 30;
    }
  }, {
    key: "getYearsInEra",
    value: function getYearsInEra() {
      // 9999-12-31 gregorian is 9920-10-10 indian.
      // Round down to 9919 for the last full year.
      return 9919;
    }
  }, {
    key: "getEras",
    value: function getEras() {
      return ['saka'];
    }
  }, {
    key: "balanceDate",
    value: function balanceDate() {}
  }]);
}((0, $af14c9812fdceb33$exports.GregorianCalendar));